import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/classroom_meeting`;

export const ACTION_TYPES = {
  FETCH_CLASSMEET_LIST: 'classmeet/FETCH_CLASSMEET_LIST',
  FETCH_CLASSMEET: 'classmeet/FETCH_CLASSMEET',
  CREATE_CLASSMEET: 'classmeet/CREATE_CLASSMEET',
  UPDATE_CLASSMEET: 'classmeet/UPDATE_CLASSMEET',
  DELETE_CLASSMEET: 'classmeet/DELETE_CLASSMEET',
  RESET: 'classmeet/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entity: {}, //defaultValue
};

// REDUCER
const classMeetingReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CLASSMEET_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CLASSMEET):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CLASSMEET):
    case REQUEST(ACTION_TYPES.UPDATE_CLASSMEET):
    case REQUEST(ACTION_TYPES.DELETE_CLASSMEET):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CLASSMEET_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CLASSMEET):
    case FAILURE(ACTION_TYPES.CREATE_CLASSMEET):
    case FAILURE(ACTION_TYPES.UPDATE_CLASSMEET):
    case FAILURE(ACTION_TYPES.DELETE_CLASSMEET):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSMEET_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSMEET):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CLASSMEET):
    case SUCCESS(ACTION_TYPES.UPDATE_CLASSMEET):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CLASSMEET):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default classMeetingReducer;

// ACTIONS
export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_CLASSMEET,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = (entity, courseId) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CLASSMEET,
    payload: axios.post(`${apiUrl}`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getEntitiesByCourseId(courseId,null,10,null));
  return result;
};

export const updateEntity = (entity, id, courseId) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CLASSMEET,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntitiesByCourseId(courseId,null,10,null));
  return result;
};

export const deleteEntity = (id, courseId) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CLASSMEET,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: {
      errorMessage: `Gagal hapus!`,
      successMessage: `Berhasil Hapus!`,
    },
  });
  dispatch(getEntitiesByCourseId(courseId,null,10,null));
  return result;
};

export const getEntitiesByCourseId = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_CLASSMEET_LIST,
  payload: axios.get(`${apiUrl}/course/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});


export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
